import { Api } from '../../Services/Api'
import { Users } from '../../Services/users'

function normalizeProductCatalog(response, dataModelsForNormalize) {
    if (response?.catalogs?.length) {
        const data = response.catalogs.map((catalog) => {
            return {
                ...catalog.models[0],
                user: Users().getUserById(catalog.models?.[0].userId)?.name,
                dataModel: dataModelsForNormalize.find(
                    (dm) => dm._id === catalog.modelId,
                )?.name,
                _id: catalog._id,
            }
        })
        return data.sort(
            (a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt),
        )
    } else {
        return []
    }
}

export function getAllProductCatalogs(dataModelsForNormalize) {
    const page = 1
    const limit = 10000
    return Api()
        .get(`api/product-catalogs/all?page=${page}&limit=${limit}`)
        .then((response) => {
            const data = normalizeProductCatalog(
                response,
                dataModelsForNormalize,
            )
            return data
        })
}

export function getProductCatalogById({ id }) {
    return Api().get(`api/product-catalogs/${id}`)
}

export function createProductCatalog(entity, dataModelsForNormalize) {
    return Api()
        .post(`api/product-catalogs/create`, entity)
        .then((response) =>
            normalizeProductCatalog(response, dataModelsForNormalize),
        )
}

export function productCatalogUpdate({
    name,
    catalogId,
    modelId,
    internalId,
    direction,
    rules,
    description,
    globalParameters,
}) {
    return Api().put(`api/product-catalogs/update/${catalogId}`, {
        name,
        catalogId,
        modelId,
        direction,
        internalId,
        rules,
        description,
        globalParameters,
    })
}

export function archiveProductCatalogById(id) {
    return Api().patch(`api/product-catalogs/archive/${id}`)
}

export function getProductCatalogsByDataModelId(
    { page = 0, limit = 1000, modelId },
    dataModelsForNormalize,
) {
    return Api()
        .get(
            `api/product-catalogs/data-model/${modelId}?page=${page}&limit=${limit}`,
        )
        .then((response) => {
            const data = normalizeProductCatalog(
                response,
                dataModelsForNormalize,
            )
            console.log(data)

            return data
        })
}
